'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Merger = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

require('arrayq');

var _resource = require('../resource');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class Merger {
    combine(items) {
        return items.reduce((item, cur) => !item ? cur : combineObj(item, cur), null);
    }
    merge(item, items) {
        return items.map(x => mergeObj(item, x));
    }
}
exports.Merger = Merger;
function combineObj(a, b) {
    let keys = (0, _keys2.default)(a).qIntersect((0, _keys2.default)(b));
    let res = {};
    keys.forEach(key => {
        let prop = combineProp(a, b, key);
        if (prop !== undefined) {
            res[key] = prop;
        }
    });
    return res;
}
function combineProp(a, b, key) {
    if (a[key] === b[key]) {
        return a[key];
    }
}
function mergeObj(input, fallback) {
    let keys = (0, _keys2.default)(input).concat((0, _keys2.default)(fallback)).qDistinct();
    let res = (0, _resource.copyFields)({}, fallback);
    keys.forEach(key => {
        let prop = mergeProp(input, fallback, key);
        if (prop !== undefined) {
            res[key] = prop;
        }
    });
    return res;
}
function mergeProp(input, fallback, key) {
    if (input[key] === undefined) {
        return fallback[key];
    } else {
        return input[key];
    }
}
//# sourceMappingURL=merger.js.map


// WEBPACK FOOTER //
// ./node_modules/redux-saga-resources/node/batch/merger.js